import {MidiRecorderInput} from "./MidiRecorderInput";
import {MidiRecorderOutput} from "./MidiRecorderOutput";
import {MidiRecorderMessageEvent} from "./MidiRecorderMessageEvent";
import {MidiDeviceHolder} from "./MidiDeviceHolder";
import {MidiDeviceCategory} from "./Midi";

export {MidiRecorder}

class MidiRecorder {

    private storage: Array<Array<MidiRecorderMessageEvent>> = [];
    private static GAP_BETWEEN_RECORDINGS = 10;
    private currentRecording: Array<MidiRecorderMessageEvent> = [];
    private recordings: Array<Array<MidiRecorderMessageEvent>> = [];
    private output: WebMidi.MIDIOutput = new MidiRecorderOutput();
    private input: WebMidi.MIDIInput = new MidiRecorderInput();
    private currentNote: number = 0;
    private pause: boolean = true;

    constructor() {
        this.output.send = (data: number[] | Uint8Array) => this.receiveMidiData(data);
    }

    public receiveMidiData(data: number[] | Uint8Array) {
        if (this.pause) {
            this.addNote(new MidiRecorderMessageEvent(data, Date.now()));
        }
    }

    private addNote(note: MidiRecorderMessageEvent) {
        if (this.currentRecording.length > 0) {
            const lastNote: MidiRecorderMessageEvent = this.currentRecording[this.currentRecording.length - 1];
            const gap: number = note.timeStamp - lastNote.timeStamp;
            if (gap / 1000 > MidiRecorder.GAP_BETWEEN_RECORDINGS) {
                console.log("new recording");
                this.recordings.push(this.currentRecording);
                this.currentRecording = [];
            }
        }
        this.currentRecording.push(note);
    }

    public getMidiInput(): MidiDeviceHolder {
        return new MidiDeviceHolder(this.input, MidiDeviceCategory.Recorder);
    }

    public getMidiOutput(): MidiDeviceHolder {
        return new MidiDeviceHolder(this.output, MidiDeviceCategory.Recorder);
    }

    public playPause() {
        if (this.pause) {
            this.pause = false;
            this.playNextNote()
        } else {
            this.pause = true;
            this.stopCurrentNote();
        }
    }

    private stopCurrentNote() {

    }

    private rewind() {
        this.pause = true;
        this.currentNote = 0;
    }

    private playNextNote() {
        if (!this.pause) {
            if (this.currentRecording.length > this.currentNote) {
                const currentNote: MidiRecorderMessageEvent = this.currentRecording[this.currentNote++];
                this.input.onmidimessage(currentNote);
                const nextNote: MidiRecorderMessageEvent = this.currentRecording[this.currentNote];
                if (nextNote) {
                    const timeToNextNote = nextNote.timeStamp - currentNote.timeStamp;
                    setTimeout(() => this.playNextNote(), timeToNextNote);
                } else {
                    this.rewind();
                }
            } else {
                this.rewind();
            }
        }
    }

}